export const taskfields = [
  {
    label: "Id",
    field: "taskCode",
    sort: "asc",
    width: 50,
  },
  {
    label: "Tipo",
    field: "taskType",
    sort: "asc",
    width: 50,
  },
  {
    label: "Prioridad",
    field: "priority",
    sort: "asc",
    width: 50,
  },
  {
    label: "Listado",
    field: "workstationCandidates",
    sort: "asc",
    width: 50,
  },
  {
    label: "Estación",
    field: "sgpWS",
    sort: "asc",
    width: 50,
  },
  {
    label: "Posición",
    field: "sgtWS",
    sort: "asc",
    width: 50,
  },
  {
    label: "Estado",
    field: "status",
    sort: "asc",
    width: 50,
  },
  {
    label: "T. Estimado",
    field: "estimatedDurationSeconds",
    sort: "asc",
    width: 50,
  },
  {
    label: "Rack",
    field: "rackCode",
    sort: "asc",
    width: 50,
  },
  {
    label: "Cara",
    field: "face_value",
    sort: "asc",
    width: 50,
  },
  {
    label: "Creada",
    field: "sgpCreated",
    sort: "asc",
    width: 100,
    searchable: true,
  },
  {
    label: "Acciones",
    field: "actions",
    sort: "asc",
    width: 100,
  },
];

export const task_status = {
  1: "1. Cancelada",
  2: "2. Finalizada",
  3: "3. Pendiente de retorno",
  4: "4. Pendiente de continuar",
  5: "5. Queue in",
  6: "6. Ejecución",
  7: "7. Enviada",
  8: "8. En cola",
  9: "9. En cola",
};

export const taskStatusBack = {
  CANCELADA: 1,
  FINALIZADA: 2,
  PENDIENTE_RETORNO: 3,
  PENDIENTE_CONTINUE: 4,
  QUEUE_IN: 5,
  EJECUTANDO: 6,
  ENVIADA: 7,
  COLA: 8,
  COLA_RESERVA: 9,
};

export const dashboardfields = [
  {
    label: "Id",
    field: "taskCode",
    sort: "asc",
    width: 50,
  },
  {
    label: "Tipo",
    field: "taskType",
    sort: "asc",
    width: 50,
  },
  {
    label: "Prioridad",
    field: "priority",
    sort: "asc",
    width: 50,
  },
  {
    label: "Listado",
    field: "workstationCandidates",
    sort: "asc",
    width: 50,
  },
  {
    label: "Estación",
    field: "sgpWS",
    sort: "asc",
    width: 50,
  },
  {
    label: "Estado",
    field: "status",
    sort: "asc",
    width: 50,
  },
  {
    label: "Rack",
    field: "rackCode",
    sort: "asc",
    width: 50,
  },
  {
    label: "Cara",
    field: "face_value",
    sort: "asc",
    width: 50,
  },
  {
    label: "Creada",
    field: "sgpCreated",
    sort: "asc",
    width: 100,
    searchable: true,
  },
];
